import { render } from "./Tasks.vue?vue&type=template&id=90f7ac38&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import "./Tasks.vue?vue&type=style&index=0&id=90f7ac38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\absan\\Documents\\GitHub\\Starport\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f7ac38"]])

export default __exports__